/**
 * Tiny logger that is a no-op in production builds.
 *
 * Use this instead of `console.*` everywhere in the app so we never leak
 * debug output (URLs, payloads, errors) to the browser console of real users.
 * In development it behaves like `console`; in production every method is a
 * no-op, so bundlers can also tree-shake the call sites away.
 */

const isDev = process.env.NODE_ENV !== 'production';

const noop = (): void => {};

export const logger = {
  log: isDev ? console.log.bind(console) : noop,
  info: isDev ? console.info.bind(console) : noop,
  warn: isDev ? console.warn.bind(console) : noop,
  error: isDev ? console.error.bind(console) : noop,
  debug: isDev ? console.debug.bind(console) : noop,
};

export type Logger = typeof logger;
